import { Link } from "react-router-dom";

// Text-based Fanpit.Club logo — bold black wordmark with pink dots on i's and 'u'
export default function Logo({ className = "", size = "md" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-3xl",
  };
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`inline-flex items-baseline font-display font-black tracking-tighter leading-none select-none ${sizes[size]} ${className}`}
      style={{ letterSpacing: "-0.06em" }}
    >
      <span className="text-[#1A1A1A]">Fanp</span>
      <span className="text-[#FA003F]">i</span>
      <span className="text-[#1A1A1A]">t.Cl</span>
      <span className="text-[#FA003F]">u</span>
      <span className="text-[#1A1A1A]">b</span>
    </Link>
  );
}
